import { gql } from '@apollo/client';

export const GET_ALL_FILES = gql`
  query GET_ALL_FILES {
    allFiles {
      id
      category {
        displayName
      }
    }
  }
`;

export const GET_MY_FILES = gql`
  query GET_MY_FILES {
    me {
      files {
        id
        updatedAt
        category {
          displayName
        }
      }
    }
  }
`;

export const GET_DOWNLOAD_FILE_TOKEN = gql`
  mutation GET_DOWNLOAD_FILE_TOKEN($id: ID!, $displayName: String!) {
    downloadFileToken(id: $id, displayName: $displayName)
  }
`;
